<div class="bl-template-page">

  <!-- B/L IMPORT PROCESSING OVERLAY -->

  <div class="bl-import-overlay" *ngIf="scanProcessing" >

    <div class="bl-import-loader-card">







      <div class="bl-import-spinner"></div>







      <strong>







        Please wait while your B/L template is prepared







      </strong>







      <span class="bl-import-loader-status">







        {{ scanProcessingStatus || 'Processing B/L...' }}







      </span>







      <div class="bl-import-progress">







        <div







          class="bl-import-progress-bar"







          [style.width.%]="scanProcessingProgress"







        ></div>







      </div>







      <small class="bl-import-loader-percent">







        {{ scanProcessingProgress }}%







      </small>







      <small class="bl-import-loader-note">







        The uploaded file is prepared as the locked visual background. No OCR reconstruction is used.







      </small>







    </div>







  </div>







  
  <!-- TEMPLATE REVIEW: nothing is loaded into the main designer until approved -->
  <div class="ocr-review-overlay" *ngIf="ocrReviewVisible">
    <div class="ocr-review-shell">
      <div class="ocr-review-header">
        <div>
          <span class="eyebrow">TEMPLATE REVIEW</span>
          <h3>Confirm the customer B/L template</h3>
          <p>
            The uploaded PDF / image will be used as the locked visual template. No OCR reconstruction is applied. After Use This Template, drag ERP data keys onto the exact value positions.
          </p>
        </div>

        <button
          nbButton
          ghost
          status="basic"
          type="button"
          [disabled]="scanProcessing"
          (click)="cancelOcrReview()"
          aria-label="Cancel OCR review"
        >
          <nb-icon icon="close-outline"></nb-icon>
        </button>
      </div>
      <div class="ocr-review-grid">
        <section class="ocr-review-pane">
          <div class="ocr-review-pane__title">
            <strong>Uploaded B/L</strong>
            <span>{{ ocrReviewFileName }}</span>
          </div>

          <div class="ocr-source-stage">
            <img
              *ngIf="ocrReviewSourceImage"
              [src]="ocrReviewSourceImage"
              alt="Uploaded BL source preview"
            />
          </div>
        </section>

        <section class="ocr-review-pane">
          <div class="ocr-review-pane__title">
            <strong>Locked visual template</strong>
            <span>
              No ERP fields are placed automatically. You will place only the data keys you need.
            </span>
          </div>

          <div class="ocr-generated-stage">
            <div class="ocr-generated-page-wrap">
              <div
                class="ocr-generated-page"
                [ngStyle]="getOcrReviewPageStyle()"
              >
                <div
                  *ngFor="let key of ocrReviewFieldKeys"
                  class="ocr-generated-field"
                  [class.low-confidence]="
                    ocrReviewConfidence[key] &&
                    (
                      !ocrReviewConfidence[key].mapped ||
                      ocrReviewConfidence[key].confidence < 0.8
                    )
                  "
                  [ngStyle]="getOcrReviewFieldStyle(key)"
                >
                  <img
                    *ngIf="
                      ocrReviewGeneratedFields[key]?.type === 'company-logo' &&
                      company.logo
                    "
                    [src]="company.logo"
                    alt="Company logo"
                  />

                  <ng-container
                    *ngIf="ocrReviewGeneratedFields[key]?.type !== 'company-logo'"
                  >
                    <small
                      *ngIf="
                        ocrReviewGeneratedFields[key]?.showLabel &&
                        ocrReviewGeneratedFields[key]?.label
                      "
                    >
                      {{ ocrReviewGeneratedFields[key]?.label }}
                    </small>

                    <span>
                      {{ getOcrReviewFieldValue(key) }}
                    </span>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="ocr-review-actions">
        <button
          nbButton
          status="basic"
          type="button"
          [disabled]="scanProcessing"
          (click)="cancelOcrReview()"
        >
          Cancel
        </button>

        <button
          *ngIf="ocrReviewSourceMode !== 'native-pdf'"
          nbButton
          status="warning"
          outline
          type="button"
          [disabled]="scanProcessing"
          (click)="regenerateOcrTemplate()"
        >
          <nb-icon icon="refresh-outline"></nb-icon>
          {{
            scanProcessing
              ? 'Re-reading...'
              : 'Prepare Again'
          }}
        </button>

        <button
          nbButton
          status="success"
          type="button"
          [disabled]="scanProcessing"
          (click)="useOcrTemplate()"
        >
          <nb-icon icon="checkmark-circle-2-outline"></nb-icon>
          Use This Template
        </button>
      </div>
    </div>
  </div>

<nb-card class="page-header-card">







    <nb-card-body>







      <div class="page-header">







        <div>







          <span class="eyebrow">DOCUMENT DESIGNER</span>







          <h2>Bill of Lading Templates</h2>







          <p>







            Set field headings, positions and sizes, then drag fields directly







            on the live Bill of Lading preview.







          </p>







        </div>







        <button







          nbButton







          status="primary"







          type="button"







          (click)="newTemplate()"







        >







          <nb-icon icon="plus-outline"></nb-icon>







          New Template







        </button>







      </div>







    </nb-card-body>







  </nb-card>







  <div class="loading-state" *ngIf="loading">







    <nb-spinner size="large"></nb-spinner>







    <span>Loading Bill of Lading templates...</span>







  </div>







  <div class="designer-layout" *ngIf="!loading">







    <!-- LEFT SETUP -->







    <nb-card class="setup-card">







      <nb-card-header>







        Template Setup







      </nb-card-header>







      <nb-card-body>







        <div class="setup-section">







          <div class="section-title">







            <span>1</span>







            Template Details







          </div>







          <div class="control">







            <label>Template Name</label>







            <input







              nbInput







              fullWidth







              type="text"







              placeholder="Example: Standard Export BL"







              [(ngModel)]="form.templateName"







            />







          </div>







          <div class="control">







  <label>View As</label>







  <select class="native-select" [ngModel]="viewMode" (ngModelChange)="setViewMode($event)">







    <option value="non-negotiable">Non-Negotiable</option>







    <option value="original">Original</option>







  </select>







  <small>One saved template with two layouts. NON uses the uploaded visual background; Original stays clean and independently editable.</small>







</div>







<div class="company-summary">







            <div class="company-logo">







              <img







                *ngIf="company.logo"







                [src]="company.logo"







                alt="Company logo"







              />







              <span *ngIf="!company.logo">







                Logo







              </span>







            </div>







            <div>







              <strong>







                {{ company.name || 'Company' }}







              </strong>







              <span>







                {{ company.address || 'Address not available' }}







              </span>







              <small>







                {{ company.telephone }}







                <ng-container *ngIf="company.email">







                  • {{ company.email }}







                </ng-container>







              </small>







            </div>







          </div>







        </div>







        <div class="setup-section">







          <div class="section-title">







            <span>2</span>







            Page Dimensions







          </div>







          <div class="two-column">







            <div class="control">







              <label>Page Width</label>







              <div class="unit-input">







                <input







                  nbInput







                  fullWidth







                  type="number"







                  min="500"







                  max="2000"







                  [(ngModel)]="form.pageWidthPx"







                  (ngModelChange)="onPageSizeChange()"







                />







                <b>PX</b>







              </div>







            </div>







            <div class="control">







              <label>Page Height</label>







              <div class="unit-input">







                <input







                  nbInput







                  fullWidth







                  type="number"







                  min="700"







                  max="3000"







                  [(ngModel)]="form.pageHeightPx"







                  (ngModelChange)="onPageSizeChange()"







                />







                <b>PX</b>







              </div>







            </div>







          </div>







        </div>







        <div class="setup-section">







          <div class="section-title">







            <span>3</span>







            Global Offset







          </div>







          <div class="offset-notice">







            Use offset only after a test print. Positive X moves all fields







            right and positive Y moves all fields down.







          </div>







          <div class="two-column">







            <div class="control">







              <label>Offset X</label>







              <input







                nbInput







                fullWidth







                type="number"







                [(ngModel)]="form.globalOffsetX"







              />







            </div>







            <div class="control">







              <label>Offset Y</label>







              <input







                nbInput







                fullWidth







                type="number"







                [(ngModel)]="form.globalOffsetY"







              />







            </div>







          </div>







        </div>







        <div class="setup-section">







          <div class="section-title">







            <span>4</span>







            Page Background







          </div>







          <div class="control" *ngIf="viewMode === 'non-negotiable'">
            <label>
              Non-Negotiable B/L Source
              <span class="required-mark">*</span>
            </label>

            <input
              #nonNegotiableScanInput
              type="file"
              accept=".png,.jpg,.jpeg,.webp,.pdf,image/png,image/jpeg,image/webp,application/pdf"
              style="display:none"
              (change)="onNonNegotiableScanSelected($event)"
            />

            <button
              nbButton
              fullWidth
              status="info"
              outline
              type="button"
              [disabled]="scanProcessing"
              (click)="nonNegotiableScanInput.click()"
            >
              <nb-icon
                [icon]="scanProcessing ? 'loader-outline' : 'upload-outline'"
              ></nb-icon>

              {{
                scanProcessing
                  ? (scanProcessingStatus || 'Preparing B/L template...')
                  : nonNegotiableScanFileName
                    ? 'Replace PDF / Image Template'
                    : 'Upload Template · PDF / Image'
              }}
            </button>

            <div
              class="bl-source-file"
              *ngIf="nonNegotiableScanFileName"
            >
              <div class="bl-source-file__info">
                <nb-icon icon="file-text-outline"></nb-icon>
                <div>
                  <strong>{{ nonNegotiableScanFileName }}</strong>
                  <small>
                    Locked visual source currently loaded in the designer.
                  </small>
                </div>
              </div>

              <button
                nbButton
                ghost
                size="tiny"
                status="danger"
                type="button"
                [disabled]="scanProcessing"
                (click)="removeNonNegotiableScan()"
              >
                Remove
              </button>
            </div>

            <small class="bl-source-help">
              PDF, PNG, JPG, JPEG and WEBP only. The source is kept as the visual template; ERP data keys are positioned manually after approval.
            </small>
          </div>

          <div class="control" *ngIf="viewMode === 'original'">







            <label>Original Layout Source</label>







            <button







              nbButton







              fullWidth







              status="primary"







              outline







              type="button"







              (click)="syncOriginalFromNonNegotiable()"







            >







              <nb-icon icon="copy-outline"></nb-icon>







              Rebuild Original from NON Alignment







            </button>







            <small>







              Copies the Non-Negotiable positions into Original, removes the scan/borders, and increases text size. Original stays independently editable afterwards.







            </small>







          </div>







          <div class="control">







            <label>Background Color</label>







            <input







              class="color-input"







              type="color"







              [(ngModel)]="form.backgroundColor"







            />







          </div>







          <div class="control">







            <label>Text Color</label>







            <input







              class="color-input"







              type="color"







              [(ngModel)]="form.textColor"







            />







          </div>







          <label class="native-check">







            <input







              type="checkbox"







              [(ngModel)]="form.isDefault"







            />







            <span>Default BL template</span>







          </label>







          <label class="native-check">







            <input







              type="checkbox"







              [(ngModel)]="form.isActive"







            />







            <span>Template is active</span>







          </label>







        </div>







        <div class="setup-actions">







          <button







            nbButton







            status="basic"







            type="button"







            (click)="resetLayout()"







          >







            Reset







          </button>







          <button







            nbButton







            status="success"







            type="button"







            [disabled]="saving"







            (click)="saveTemplate()"







          >







            <nb-icon icon="save-outline"></nb-icon>







            {{







              saving







                ? 'Saving...'







                : selectedTemplate







                  ? 'Update Template'







                  : 'Save Template'







            }}







          </button>







        </div>







      </nb-card-body>







    </nb-card>







    <!-- RIGHT AREA -->







    <div class="designer-main">







      <!-- FIELD POSITIONS -->







      <nb-card class="field-panel-card">







        <nb-card-header>







  <div class="field-panel-header">







    <span>Field Positions</span>







    <button







      nbButton







      size="small"







      status="primary"







      type="button"







      (click)="toggleAddFieldForm()"







    >







      <nb-icon







        [icon]="







          showAddFieldForm







            ? 'close-outline'







            : 'plus-outline'







        "







      ></nb-icon>







      {{







        showAddFieldForm







          ? 'Cancel'







          : 'Add Field'







      }}







    </button>







  </div>







</nb-card-header>







        <nb-card-body>







<div







  class="add-field-panel"







  *ngIf="showAddFieldForm"







>







  <div class="add-field-panel__header">







    <div>







      <strong>Add Custom Field</strong>







      <span>







        Add a new field and position it







        directly on the BL preview.







      </span>







    </div>







  </div>







  <div class="add-field-grid">







  <div class="control">







    <label>







      Field Type







      <span>*</span>







    </label>







    <select







      class="native-select"







      [(ngModel)]="newField.type"







    >







      <option value="field">







        Dynamic HBL Field







      </option>







      <option value="text">







        Static / Hardcoded Text







      </option>



      <option value="digital-stamp">

        Digital Stamp Slot

      </option>







    </select>







  </div>







  <div class="control">







    <label>







      Field Name







      <span>*</span>







    </label>







    <input







      nbInput







      fullWidth







      type="text"







      placeholder="Example: Bill of Lading Title"







      [(ngModel)]="newField.name"







    />







  </div>







  <div

    class="control"

    *ngIf="newField.type !== 'digital-stamp'"

  >







    <label>







      Heading







    </label>







    <input







      nbInput







      fullWidth







      type="text"







      placeholder="Example: Port of Loading"







      [(ngModel)]="newField.heading"







    />







  </div>







  <div

    class="control"

    *ngIf="newField.type !== 'digital-stamp'"

  >







    <label>







      {{







        newField.type === 'text'







          ? 'Static Text'







          : 'Preview Value'







      }}







      <span







        *ngIf="







          newField.type === 'text'







        "







      >







        *







      </span>







    </label>







    <textarea







      nbInput







      fullWidth







      rows="3"







      [placeholder]="







        newField.type === 'text'







          ? 'Enter the exact text to print'







          : 'Example preview value'







      "







      [(ngModel)]="







        newField.previewValue







      "







    ></textarea>







  </div>









  <div

    class="digital-stamp-slot-note"

    *ngIf="newField.type === 'digital-stamp'"

  >

    <nb-icon icon="info-outline"></nb-icon>

    <span>

      This creates a draggable/resizable stamp position on the B/L.

      The selected Telex Release, Surrender or Seawaybill stamp will

      render here when the HBL PDF is generated.

    </span>

  </div>



<div







    class="control"







    *ngIf="







      newField.type === 'field'







    "







  >







    <label>







      Data Key







      <span>*</span>







    </label>







    <input







      nbInput







      fullWidth







      type="text"







      placeholder="Example: portOfLoading"







      [(ngModel)]="







        newField.dataKey







      "







    />







  </div>







</div>







  <div class="add-field-footer">







   <label







  class="custom-checkbox"







  *ngIf="







    newField.type === 'field'







  "







>







  <input







    type="checkbox"







    [(ngModel)]="







      newField.showLabel







    "







  />







  <span>







    Show field heading







  </span>







</label>







    <div class="add-field-actions">







      <button







        nbButton







        status="basic"







        type="button"







        (click)="toggleAddFieldForm()"







      >







        Cancel







      </button>







      <button







        nbButton







        status="success"







        type="button"







        (click)="addCustomField()"







      >







        <nb-icon







          icon="plus-outline"







        ></nb-icon>







        Add Field







      </button>







    </div>







  </div>







</div>







          <div class="field-panel-help">







            Change any value below or drag a field directly inside the BL







            preview. Both remain synchronized.







          </div>

          <div class="print-align-toolbar">
            <div class="print-align-toolbar__text">
              <strong>Print Alignment</strong>
              <small>
                Auto-aligns only nearby ERP data keys into clean rows and columns.
                Existing template alignment changes only when you click Auto Align.
              </small>
            </div>

            <div class="print-align-toolbar__actions">
              <button
                nbButton
                size="small"
                status="info"
                type="button"
                (click)="autoAlignDataKeys()"
              >
                Auto Align Data Keys
              </button>

              <button
                *ngIf="canUndoAutoAlign"
                nbButton
                size="small"
                status="basic"
                outline
                type="button"
                (click)="undoAutoAlign()"
              >
                Undo Align
              </button>
            </div>
          </div>







          <div class="field-table-wrapper">







            <div class="field-table">







              <div class="field-table-header">







  <span>Field</span>







  <span>Heading</span>







  <span>Preview Value</span>







  <span>Data Key</span>







  <span>X</span>







  <span>Y</span>







  <span>Width</span>







  <span>Height</span>







  <span>Font</span>







  <span>Family</span>







  <span>Weight</span>







<span>Show Heading</span>







<span>Lock</span>







  <span>Action</span>







</div>







              <div







                class="field-row"







                *ngFor="let key of fieldPanelKeys; trackBy: trackByFieldKey"







                [class.active]="activeFieldKey === key"







                (click)="selectField(key)"







              >







                <strong>{{ getFieldDisplayName(key) }}</strong>







                <!-- ================= HEADING ================= -->







<input







  nbInput







  type="text"







  placeholder="Heading"







  [ngModel]="







    key === 'footer'







      ? 'Footer'







      : fields[key].label







  "







  (ngModelChange)="







    key !== 'footer' &&







    updateField(







      key,







      'label',







      $event







    )







  "







  [readonly]="key === 'footer'"







  [disabled]="







    fields[key].type === 'company-logo' ||







    fields[key].type === 'company-name' ||







    fields[key].type === 'company-address' ||







    fields[key].type === 'text' ||







    fields[key].type === 'company-contact' ||



    fields[key].type === 'digital-stamp'







  "







/>







<!-- ================= PREVIEW VALUE ================= -->







<input







  nbInput







  type="text"







  placeholder="Preview value"







  [ngModel]="







    key === 'footer'







      ? fixedFooterText







      : fields[key].previewValue







  "







  (ngModelChange)="







    key !== 'footer' &&







    updateField(







      key,







      'previewValue',







      $event







    )







  "







  [readonly]="key === 'footer'"







  [disabled]="







    fields[key].type === 'company-logo' ||







    fields[key].type === 'company-name' ||







    fields[key].type === 'company-address' ||







    fields[key].type === 'company-contact' ||



    fields[key].type === 'digital-stamp'







  "







/>







<!-- ================= DATA KEY ================= -->







<input







  nbInput







  type="text"







  [placeholder]="







    key === 'footer'







      ? 'Not applicable'







      : 'Data key'







  "







  [ngModel]="







    key === 'footer'







      ? ''







      : fields[key].dataKey







  "







  (ngModelChange)="







    key !== 'footer' &&







    updateField(







      key,







      'dataKey',







      $event







    )







  "







  [readonly]="key === 'footer'"







  [disabled]="







    fields[key].type === 'company-logo' ||







    fields[key].type === 'company-name' ||







    fields[key].type === 'company-address' ||







    fields[key].type === 'company-contact' ||



    fields[key].type === 'digital-stamp'







  "







/>







                <input nbInput type="number" placeholder="X"







                  [ngModel]="fields[key].x"







                  (ngModelChange)="updateField(key, 'x', $event)" />







                <input nbInput type="number" placeholder="Y"







                  [ngModel]="fields[key].y"







                  (ngModelChange)="updateField(key, 'y', $event)" />







                <input nbInput type="number" placeholder="Width"







                  [ngModel]="fields[key].width"







                  (ngModelChange)="updateField(key, 'width', $event)" />







                <input nbInput type="number" placeholder="Height"







                  [ngModel]="fields[key].height"







                  (ngModelChange)="updateField(key, 'height', $event)" />







                <input nbInput type="number" min="5" max="72" placeholder="Font"







                  [ngModel]="fields[key].fontSize"







                  (ngModelChange)="updateField(key, 'fontSize', $event)" />







                <select
                  class="native-select"
                  [ngModel]="fields[key].fontFamily || 'helvetica'"
                  (ngModelChange)="updateField(key, 'fontFamily', $event)"
                  title="Font family"
                >







                  <option
                    *ngFor="let font of fontFamilyOptions"
                    [value]="font.value"
                  >
                    {{ font.label }}
                  </option>







                </select>







                <select class="native-select"







                  [ngModel]="fields[key].fontWeight"







                  (ngModelChange)="updateField(key, 'fontWeight', $event)">







                  <option value="normal">Normal</option>







                  <option value="bold">Bold</option>







                </select>







<label class="row-checkbox">







  <input







    type="checkbox"







    [ngModel]="







      key === 'footer'







        ? false







        : fields[key].showLabel







    "







    (ngModelChange)="







      key !== 'footer' &&







      updateField(







        key,







        'showLabel',







        $event







      )







    "







    [disabled]="







      key === 'footer' ||







      fields[key].type === 'company-logo' ||







      fields[key].type === 'company-name' ||







      fields[key].type === 'company-address' ||







      fields[key].type === 'company-contact' ||



      fields[key].type === 'digital-stamp'







    "







  />







</label>







<label class="row-checkbox">







  <input







    type="checkbox"







    [ngModel]="fields[key].locked"







    (ngModelChange)="







      updateField(







        key,







        'locked',







        $event







      )







    "







  />







</label>







<div class="field-action-cell">







  <button







    *ngIf="canDeleteField(key)"







    nbButton







    ghost







    size="tiny"







    status="danger"







    type="button"







    title="Delete field"







    (click)="







      $event.stopPropagation();







      removeField(key)







    "







  >







    <nb-icon







      icon="trash-2-outline"







    ></nb-icon>







  </button>







  <span







    *ngIf="!canDeleteField(key)"







    class="protected-field"







    title="This field is required"







  >







    Required







  </span>







</div>







              </div>







            </div>







          </div>







        </nb-card-body>







      </nb-card>







      <!-- LIVE PREVIEW -->







      
      <!-- ERP DATA KEYS — full-width, directly above the editable B/L -->
      <!-- ERP DATA KEY LIBRARY -->
      <nb-card class="data-key-library-card data-key-library-card--wide" >
        <nb-card-header>
          <div class="field-panel-header">
            <div>
              <span>ERP Data Keys</span>
              <small>Drag a key onto the exact value position on the B/L.</small>
            </div>
          </div>
        </nb-card-header>
        <nb-card-body>
          <div class="data-key-search">
            <input
              nbInput
              fullWidth
              type="text"
              placeholder="Search consignee, BL no, weight, company..."
              [(ngModel)]="dataKeySearch"
            />
          </div>

          <div class="data-key-palette">
            <button
              *ngFor="let item of dataKeyPaletteItems; trackBy: trackByPaletteItem"
              type="button"
              class="data-key-palette__item"
              draggable="true"
              (dragstart)="onDataKeyDragStart($event, item)"
              (dragend)="onDataKeyDragEnd()"
              (click)="addDataKeyFromPalette(item)"
              [title]="'Drag to B/L: ' + item.dataKey"
            >
              <span class="data-key-palette__category">{{ item.category }}</span>
              <strong>{{ item.label }}</strong>
              <code>{{ item.dataKey }}</code>
              <nb-icon icon="move-outline"></nb-icon>
            </button>
          </div>

          <div class="data-key-help">
            Drag directly onto the B/L beside this panel. Click = add near the top for manual positioning.
            Fields are transparent and label-free so the uploaded template remains untouched.
          </div>
        </nb-card-body>
      </nb-card>

      <!-- LIVE PREVIEW -->
      <nb-card class="preview-card">







        <nb-card-header>







          <div class="preview-header">







            <div>







              <strong>Live BL Preview</strong>







              <span>







                  Drag a field to move it. Select it and use the handles to resize it.







              </span>







            </div>







            <div class="selected-field-remove" *ngIf="activeFieldKey && fields[activeFieldKey]" style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;justify-content:flex-end;margin-left:auto;">
              <span style="font-size:12px;opacity:.8;">Selected: {{ getFieldDisplayName(activeFieldKey) }}</span>
              <button
                *ngIf="canDeleteField(activeFieldKey)"
                nbButton
                size="small"
                status="danger"
                outline
                type="button"
                title="Remove selected field from this B/L layout"
                (click)="$event.stopPropagation(); removeField(activeFieldKey)"
              >
                <nb-icon icon="trash-2-outline"></nb-icon>
                Remove Selected Field
              </button>
              <small *ngIf="!canDeleteField(activeFieldKey)" style="opacity:.65;">Required field</small>
            </div>

            <div class="preview-size">







              {{ currentPageWidth }} ×







              {{ currentPageHeight }}px







            </div>







          </div>







        </nb-card-header>







        <nb-card-body>







          <div class="preview-workspace">







            <div class="preview-badge">







              DRAG ERP DATA KEYS HERE · MOVE / RESIZE AFTER DROP







            </div>







            <div







              class="bl-preview"

              [ngStyle]="getPageStyle()"
              (dragover)="onTemplateCanvasDragOver($event)"
              (drop)="onTemplateCanvasDrop($event)"







            >







            <ng-template







  #resizeHandles







  let-fieldKey="fieldKey"







>







  <ng-container







    *ngIf="







      activeFieldKey === fieldKey &&







      !fields[fieldKey].locked







    "







  >







    <span







      *ngFor="







        let direction of resizeDirections







      "







      class="resize-handle"







      [ngClass]="







        'resize-handle--' + direction







      "







      (mousedown)="







        startResize(







          $event,







          fieldKey,







          direction







        )







      "







    ></span>







  </ng-container>







</ng-template>







              <ng-container







  *ngFor="







    let key of fieldKeys;







    trackBy: trackByFieldKey







  "







>







  <!-- ================= COMPANY LOGO ================= -->







  <div







    *ngIf="







      fields[key].visible &&







      fields[key].type === 'company-logo'







    "







    class="preview-field logo-field"







    [class.active]="activeFieldKey === key"







    [class.locked]="fields[key].locked"

    [class.digital-stamp-field]="fields[key].type === 'digital-stamp'"







    [ngStyle]="getFieldStyle(key)"







    (click)="selectField(key)"







    (mousedown)="startDrag($event, key)"







  >







    <img







      *ngIf="company.logo; else liveLogoFallback"







      [src]="company.logo"







      [alt]="company.name || 'Company Logo'"







      draggable="false"







    />







    <ng-template #liveLogoFallback>







      <span>Company Logo</span>







    </ng-template>







    <ng-container







  *ngTemplateOutlet="







    resizeHandles;







    context: {







      fieldKey: key







    }







  "







></ng-container>







  </div>







  <!-- ================= COMPANY NAME ================= -->







  <div







    *ngIf="







      fields[key].visible &&







      fields[key].type === 'company-name'







    "







    class="preview-field text-field company-field"







    [class.active]="activeFieldKey === key"







    [class.locked]="fields[key].locked"

    [class.digital-stamp-field]="fields[key].type === 'digital-stamp'"







    [ngStyle]="getFieldStyle(key)"







    (click)="selectField(key)"







    (mousedown)="startDrag($event, key)"







  >







    <div class="field-value">







      {{ company.name || 'Company Name' }}







    </div>







    <ng-container







  *ngTemplateOutlet="







    resizeHandles;







    context: {







      fieldKey: key







    }







  "







></ng-container>







  </div>







  <!-- ================= COMPANY ADDRESS ================= -->







  <div







    *ngIf="







      fields[key].visible &&







      fields[key].type === 'company-address'







    "







    class="preview-field text-field company-field"







    [class.active]="activeFieldKey === key"







    [class.locked]="fields[key].locked"

    [class.digital-stamp-field]="fields[key].type === 'digital-stamp'"







    [ngStyle]="getFieldStyle(key)"







    (click)="selectField(key)"







    (mousedown)="startDrag($event, key)"







  >







    <div class="field-value">







      {{ company.address || 'Company Address' }}







    </div>







    <ng-container







  *ngTemplateOutlet="







    resizeHandles;







    context: {







      fieldKey: key







    }







  "







></ng-container>







  </div>







  <!-- ================= COMPANY CONTACT ================= -->







  <div







    *ngIf="







      fields[key].visible &&







      fields[key].type === 'company-contact'







    "







    class="preview-field text-field company-field"







    [class.active]="activeFieldKey === key"







    [class.locked]="fields[key].locked"

    [class.digital-stamp-field]="fields[key].type === 'digital-stamp'"







    [ngStyle]="getFieldStyle(key)"







    (click)="selectField(key)"







    (mousedown)="startDrag($event, key)"







  >







    <div class="field-value">







      <ng-container *ngIf="company.telephone">







        Tel: {{ company.telephone }}







      </ng-container>







      <ng-container







        *ngIf="company.telephone && company.email"







      >







        &nbsp;|&nbsp;







      </ng-container>







      <ng-container *ngIf="company.email">







        Email: {{ company.email }}







      </ng-container>







      <ng-container







        *ngIf="







          company.ntn &&







          (company.telephone || company.email)







        "







      >







        &nbsp;|&nbsp;







      </ng-container>







      <ng-container *ngIf="company.ntn">







        NTN: {{ company.ntn }}







      </ng-container>







      <ng-container







        *ngIf="







          !company.telephone &&







          !company.email &&







          !company.ntn







        "







      >







        Company Contact







      </ng-container>







    </div>







    <ng-container







  *ngTemplateOutlet="







    resizeHandles;







    context: {







      fieldKey: key







    }







  "







></ng-container>







  </div>







  <!-- ================= NORMAL / CUSTOM FIELDS ================= -->







  <div







    *ngIf="







      fields[key].visible &&







      fields[key].type !== 'company-logo' &&







      fields[key].type !== 'company-name' &&







      fields[key].type !== 'company-address' &&







      fields[key].type !== 'company-contact'







    "







    class="preview-field text-field"







    [class.active]="activeFieldKey === key"







    [class.locked]="fields[key].locked"

    [class.digital-stamp-field]="fields[key].type === 'digital-stamp'"







    [ngStyle]="getFieldStyle(key)"







    (click)="selectField(key)"







    (mousedown)="startDrag($event, key)"







  >







    <div







      class="field-heading"







      *ngIf="fields[key].showLabel"







    >







      {{ fields[key].label }}







    </div>







    <div
      class="field-value"
      *ngIf="fields[key].type !== 'container-table'; else containerTablePreview"
    >
      {{ getPreviewValue(key) }}
    </div>

    <ng-template #containerTablePreview>
      <div
        class="field-value"
        style="width:100%;height:100%;display:flex;flex-direction:column;overflow:hidden;padding:0;"
      >
        <div
          *ngIf="fields[key].containerTableShowHeader"
          style="display:grid;grid-template-columns:24fr 15fr 14fr 14fr 16fr 12fr;font-weight:700;border-bottom:2px solid currentColor;font-size:0.82em;line-height:1.15;padding-bottom:2px;margin-bottom:2px;"
        >
          <span style="padding:2px 3px;">Container</span>
          <span style="padding:2px 3px;">Seal</span>
          <span style="padding:2px 3px;">GR WT</span>
          <span style="padding:2px 3px;">NT WT</span>
          <span style="padding:2px 3px;">PCKGS</span>
          <span style="padding:2px 3px;">CBM</span>
        </div>

        <div
          *ngFor="let row of [1, 2, 3]"
          style="display:grid;grid-template-columns:24fr 15fr 14fr 14fr 16fr 12fr;font-size:0.80em;line-height:1.2;"
        >
          <span style="padding:2px 3px;">{{ row === 1 ? 'CONT0012345' : row === 2 ? 'CONT0067890' : 'CONT0098765' }}</span>
          <span style="padding:2px 3px;">{{ row === 1 ? 'SEAL001' : row === 2 ? 'SEAL002' : 'SEAL003' }}</span>
          <span style="padding:2px 3px;">{{ row === 1 ? '1200 KG' : row === 2 ? '1350 KG' : '980 KG' }}</span>
          <span style="padding:2px 3px;">{{ row === 1 ? '1100 KG' : row === 2 ? '1250 KG' : '900 KG' }}</span>
          <span style="padding:2px 3px;">{{ row === 1 ? '25' : row === 2 ? '30' : '18' }}</span>
          <span style="padding:2px 3px;">{{ row === 1 ? '18.50' : row === 2 ? '20.10' : '14.20' }}</span>
        </div>
      </div>
    </ng-template>







<ng-container







  *ngTemplateOutlet="







    resizeHandles;







    context: {







      fieldKey: key







    }







  "







></ng-container>







  </div>







</ng-container>







<ng-container







  *ngIf="







    activeTextField as selectedField







  "







>







  <div







    class="inline-typography-toolbar"







    [ngStyle]="







      getInlineTypographyStyle()







    "







    (mousedown)="







      $event.stopPropagation()







    "







    (click)="







      $event.stopPropagation()







    "







  >







    <!-- FIRST ROW -->







    <div class="inline-toolbar-row">







      <!-- FONT SIZE -->







      <div class="inline-tool-group">







        <span class="inline-tool-label">







          Font







        </span>







        <button







          type="button"







          class="inline-tool-button"







          title="Decrease font size"







          (click)="







            changeActiveFontSize(-1)







          "







        >







          −







        </button>







        <input







          class="inline-tool-number"







          type="number"







          min="5"







          max="72"







          step="1"







          [ngModel]="







            selectedField.fontSize







          "







          (ngModelChange)="







            updateField(







              selectedField.key,







              'fontSize',







              $event







            )







          "







        />







        <button







          type="button"







          class="inline-tool-button"







          title="Increase font size"







          (click)="







            changeActiveFontSize(1)







          "







        >







          +







        </button>







      </div>







      <!-- LINE HEIGHT -->







      <div class="inline-tool-group">







        <span class="inline-tool-label">







          Line







        </span>







        <button







          type="button"







          class="inline-tool-button"







          title="Decrease line height"







          (click)="







            changeActiveLineHeight(-0.05)







          "







        >







          −







        </button>







        <input







          class="







            inline-tool-number







            line-height-input







          "







          type="number"







          min="0.7"







          max="3"







          step="0.05"







          [ngModel]="







            selectedField.lineHeight ||







            1.25







          "







          (ngModelChange)="







            updateField(







              selectedField.key,







              'lineHeight',







              $event







            )







          "







        />







        <button







          type="button"







          class="inline-tool-button"







          title="Increase line height"







          (click)="







            changeActiveLineHeight(0.05)







          "







        >







          +







        </button>







      </div>







      <!-- NORMAL / BOLD -->







      <div class="inline-tool-group">







        <button







          type="button"







          class="inline-format-button"







          [class.active]="







            selectedField.fontWeight ===







            'normal'







          "







          (click)="







            setActiveFontWeight(







              'normal'







            )







          "







        >







          Normal







        </button>







        <button







          type="button"







          class="







            inline-format-button







            format-bold







          "







          [class.active]="







            selectedField.fontWeight ===







            'bold'







          "







          (click)="







            setActiveFontWeight(







              'bold'







            )







          "







        >







          Bold







        </button>







      </div>







      <!-- ITALIC / UNDERLINE / STRIKE -->







      <div class="inline-tool-group">







        <button







          type="button"







          class="







            inline-square-button







            format-italic







          "







          title="Italic"







          [class.active]="







            selectedField.fontStyle ===







            'italic'







          "







          (click)="toggleActiveItalic()"







        >







          I







        </button>







        <button







          type="button"







          class="







            inline-square-button







            format-underline







          "







          title="Underline"







          [class.active]="







            selectedField.textDecoration ===







            'underline'







          "







          (click)="







            toggleActiveTextDecoration(







              'underline'







            )







          "







        >







          U







        </button>







        <button







          type="button"







          class="







            inline-square-button







            format-strike







          "







          title="Strikethrough"







          [class.active]="







            selectedField.textDecoration ===







            'line-through'







          "







          (click)="







            toggleActiveTextDecoration(







              'line-through'







            )







          "







        >







          S







        </button>







      </div>







    </div>







    <!-- SECOND ROW -->







    <div







      class="







        inline-toolbar-row







        inline-toolbar-row--secondary







      "







    >







      <!-- ALIGNMENT -->







      <div class="inline-tool-group">







        <span class="inline-tool-label">







          Align







        </span>







        <button







          type="button"







          class="inline-square-button"







          title="Align left"







          [class.active]="







            selectedField.textAlign ===







            'left'







          "







          (click)="







            setActiveTextAlign('left')







          "







        >







          L







        </button>







        <button







          type="button"







          class="inline-square-button"







          title="Align center"







          [class.active]="







            selectedField.textAlign ===







            'center'







          "







          (click)="







            setActiveTextAlign('center')







          "







        >







          C







        </button>







        <button







          type="button"







          class="inline-square-button"







          title="Align right"







          [class.active]="







            selectedField.textAlign ===







            'right'







          "







          (click)="







            setActiveTextAlign('right')







          "







        >







          R







        </button>







        <button







          type="button"







          class="inline-square-button"







          title="Justify"







          [class.active]="







            selectedField.textAlign ===







            'justify'







          "







          (click)="







            setActiveTextAlign('justify')







          "







        >







          J







        </button>







      </div>







      <div class="inline-toolbar-divider"></div>







      <!-- BORDERS -->







      <div class="inline-tool-group border-tools">







        <span class="inline-tool-label">







          Border







        </span>







        <button







          type="button"







          class="inline-border-button"







          title="Toggle top border"







          [class.active]="







            getFieldBorderWidth(







              selectedField,







              'top'







            ) > 0







          "







          (click)="







            toggleActiveBorder('top')







          "







        >







          <span







            class="







              border-icon







              border-icon--top







            "







          ></span>







        </button>







        <button







          type="button"







          class="inline-border-button"







          title="Toggle right border"







          [class.active]="







            getFieldBorderWidth(







              selectedField,







              'right'







            ) > 0







          "







          (click)="







            toggleActiveBorder('right')







          "







        >







          <span







            class="







              border-icon







              border-icon--right







            "







          ></span>







        </button>







        <button







          type="button"







          class="inline-border-button"







          title="Toggle bottom border"







          [class.active]="







            getFieldBorderWidth(







              selectedField,







              'bottom'







            ) > 0







          "







          (click)="







            toggleActiveBorder('bottom')







          "







        >







          <span







            class="







              border-icon







              border-icon--bottom







            "







          ></span>







        </button>







        <button







          type="button"







          class="inline-border-button"







          title="Toggle left border"







          [class.active]="







            getFieldBorderWidth(







              selectedField,







              'left'







            ) > 0







          "







          (click)="







            toggleActiveBorder('left')







          "







        >







          <span







            class="







              border-icon







              border-icon--left







            "







          ></span>







        </button>







        <button







          type="button"







          class="inline-border-button"







          title="Show all borders"







          (click)="







            setAllActiveBorders(true)







          "







        >







          <span







            class="







              border-icon







              border-icon--all







            "







          ></span>







        </button>







        <button







          type="button"







          class="inline-border-button"







          title="Remove all borders"







          (click)="







            setAllActiveBorders(false)







          "







        >







          <span







            class="







              border-icon







              border-icon--none







            "







          ></span>







        </button>







      </div>







    </div>







  </div>







</ng-container>







            </div>







          </div>







        </nb-card-body>







      </nb-card>

    </div>

  </div>

  <!-- SAVED TEMPLATES -->







  <nb-card







    class="saved-card"







    *ngIf="!loading"







  >







    <nb-card-header>







      Saved BL Templates







    </nb-card-header>







    <nb-card-body>







      <div class="saved-table-wrapper">







        <table>







          <thead>







            <tr>







              <th>Template</th>







              <th>Company</th>







              <th>Page Size</th>







              <th>Default</th>







              <th>Status</th>







              <th class="actions-column">







                Actions







              </th>







            </tr>







          </thead>







          <tbody>







            <tr *ngIf="!templates.length">







              <td







                colspan="6"







                class="empty-cell"







              >







                No saved BL templates found.







              </td>







            </tr>







            <tr *ngFor="let template of templates; trackBy: trackByTemplateId">







              <td>







                <strong>







                  {{ template.templateName }}







                </strong>







              </td>







              <td>







                {{ company.name || template.companyId }}







              </td>







              <td>







                {{ template.pageWidthPx }} ×







                {{ template.pageHeightPx }}px







              </td>







              <td>







                <span







                  class="status default"







                  *ngIf="template.isDefault"







                >







                  Default







                </span>







                <span







                  class="status neutral"







                  *ngIf="!template.isDefault"







                >







                  Standard







                </span>







              </td>







              <td>







                <span







                  class="status active"







                  *ngIf="template.isActive"







                >







                  Active







                </span>







                <span







                  class="status inactive"







                  *ngIf="!template.isActive"







                >







                  Inactive







                </span>







              </td>







              <td>







                <div class="table-actions">







                      <button







                      nbButton







                      size="tiny"







                      status="primary"







                      type="button"







                      (click)="viewTemplate(template)"







                    >







                      <nb-icon icon="eye-outline"></nb-icon>







                      View







                    </button>







                  <button







                    nbButton







                    size="tiny"







                    status="info"







                    type="button"







                    (click)="editTemplate(template)"







                  >







                    Edit







                  </button>







                  <button







                    nbButton







                    size="tiny"







                    status="danger"







                    type="button"







                    (click)="deleteTemplate(template)"







                  >







                    Delete







                  </button>







                </div>







              </td>







            </tr>







          </tbody>







        </table>







      </div>







    </nb-card-body>







  </nb-card>







</div>







<ng-template







  #templateViewDialog







  let-ref="dialogRef"







>







  <nb-card class="template-view-card">







    <nb-card-header>







      <div class="template-view-header">







        <div>







          <strong>







            {{







              viewingTemplate?.templateName ||







              'BL Template'







            }}







          </strong>







          <span>







            Full template preview







          </span>







        </div>







        <div class="control">







  <label>View As</label>







  <select class="native-select" [ngModel]="viewMode" (ngModelChange)="setViewMode($event)">







    <option value="non-negotiable">Non-Negotiable</option>







    <option value="original">Original</option>







  </select>







  <small>One saved template with two independent layouts. OCR builds the NON layout; Original stays borderless and independently editable.</small>







</div>







<button







          nbButton







          ghost







          size="small"







          status="basic"







          type="button"







          (click)="ref.close()"







          aria-label="Close preview"







        >







          <nb-icon







            icon="close-outline"







          ></nb-icon>







        </button>







      </div>







    </nb-card-header>







    <nb-card-body>







      <div class="template-view-toolbar">







        <div>







          <span>Page Size</span>







          <strong>







            {{







              viewingTemplate?.pageWidthPx







            }}







            ×







            {{







              viewingTemplate?.pageHeightPx







            }}px







          </strong>







        </div>







        <div>







          <span>Status</span>







          <strong>







            {{







              viewingTemplate?.isActive







                ? 'Active'







                : 'Inactive'







            }}







          </strong>







        </div>







        <div>







          <span>Type</span>







          <strong>







            {{







              viewingTemplate?.isDefault







                ? 'Default'







                : 'Standard'







            }}







          </strong>







        </div>







      </div>







      <div class="template-view-workspace">







        <div







          class="template-view-page"







          [ngStyle]="getViewingPageStyle()"







        >







          <ng-container







  *ngFor="







    let key of getViewingFieldKeys();







    trackBy: trackByFieldKey







  "







>







  <!-- ================= COMPANY LOGO ================= -->







  <div







    *ngIf="







      viewingTemplate?.fields?.[key]?.visible &&







      viewingTemplate?.fields?.[key]?.type ===







        'company-logo'







    "







    class="template-view-field logo-field"







    [ngStyle]="getViewingFieldStyle(key)"







  >







    <img







      *ngIf="company.logo; else viewLogoFallback"







      [src]="company.logo"







      [alt]="company.name || 'Company Logo'"







      draggable="false"







    />







    <ng-template #viewLogoFallback>







      <span>Company Logo</span>







    </ng-template>







  </div>







  <!-- ================= COMPANY NAME ================= -->







  <div







    *ngIf="







      viewingTemplate?.fields?.[key]?.visible &&







      viewingTemplate?.fields?.[key]?.type ===







        'company-name'







    "







    class="template-view-field text-field company-field"







    [ngStyle]="getViewingFieldStyle(key)"







  >







    <div class="field-value">







      {{ company.name || 'Company Name' }}







    </div>







  </div>







  <!-- ================= COMPANY ADDRESS ================= -->







  <div







    *ngIf="







      viewingTemplate?.fields?.[key]?.visible &&







      viewingTemplate?.fields?.[key]?.type ===







        'company-address'







    "







    class="template-view-field text-field company-field"







    [ngStyle]="getViewingFieldStyle(key)"







  >







    <div class="field-value">







      {{ company.address || 'Company Address' }}







    </div>







  </div>







  <!-- ================= COMPANY CONTACT ================= -->







  <div







    *ngIf="







      viewingTemplate?.fields?.[key]?.visible &&







      viewingTemplate?.fields?.[key]?.type ===







        'company-contact'







    "







    class="template-view-field text-field company-field"







    [ngStyle]="getViewingFieldStyle(key)"







  >







    <div class="field-value">







      <ng-container *ngIf="company.telephone">







        Tel: {{ company.telephone }}







      </ng-container>







      <ng-container







        *ngIf="company.telephone && company.email"







      >







        &nbsp;|&nbsp;







      </ng-container>







      <ng-container *ngIf="company.email">







        Email: {{ company.email }}







      </ng-container>







      <ng-container







        *ngIf="







          company.ntn &&







          (company.telephone || company.email)







        "







      >







        &nbsp;|&nbsp;







      </ng-container>







      <ng-container *ngIf="company.ntn">







        NTN: {{ company.ntn }}







      </ng-container>







      <ng-container







        *ngIf="







          !company.telephone &&







          !company.email &&







          !company.ntn







        "







      >







        Company Contact







      </ng-container>







    </div>







  </div>







  <!-- ================= NORMAL / CUSTOM FIELDS ================= -->







  <div







    *ngIf="







      viewingTemplate?.fields?.[key]?.visible &&







      viewingTemplate?.fields?.[key]?.type !==







        'company-logo' &&







      viewingTemplate?.fields?.[key]?.type !==







        'company-name' &&







      viewingTemplate?.fields?.[key]?.type !==







        'company-address' &&







      viewingTemplate?.fields?.[key]?.type !==







        'company-contact'







    "







    class="template-view-field text-field"







    [ngStyle]="getViewingFieldStyle(key)"







  >







    <div







      class="field-heading"







      *ngIf="







        viewingTemplate







          ?.fields?.[key]







          ?.showLabel







      "







    >







      {{







        viewingTemplate







          ?.fields?.[key]







          ?.label







      }}







    </div>







    <div class="field-value">







      {{ getViewingPreviewValue(key) }}







    </div>







  </div>







</ng-container>







        </div>







      </div>







    </nb-card-body>







    <nb-card-footer>







      <div class="template-view-footer">







        <button







          nbButton







          status="basic"







          type="button"







          (click)="ref.close()"







        >







          Close







        </button>







        <button







          nbButton







          status="primary"







          type="button"







          (click)="







            ref.close();







            editTemplate(







              viewingTemplate!







            )







          "







        >







          <nb-icon







            icon="edit-2-outline"







          ></nb-icon>







          Edit Template







        </button>







      </div>







    </nb-card-footer>







  </nb-card>







</ng-template>








